import { render } from "./MyButton.vue?vue&type=template&id=9453c0e2"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cc/www/doit2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__